import { RootState } from '../../store';

export const getManualVerificationHttpsProviders = (state: RootState) =>
  state.manualVerificationProviderDetails.manualVerificationHttpsProviders;
export const getLoading = (state: RootState) =>
  state.manualVerificationProviderDetails.isLoading;
export const getSelectedManualVerificationSessionProviderData = (state: RootState) =>
  state.manualVerificationProviderDetails.selectedManualVerificationSessionProviderData;
